import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { baseGrid } from '@helpers/grid';
import { imageCoverContainer } from '@helpers/image';
import { Device, from, until } from '@helpers/media';
import { contentStyles, h4, paragraphSmall } from '@helpers/typography';
import Image from '@stories/Components/Misc/Image/Image';
import SectionWrapper from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '@stories/Components/Misc/SectionWrapper/SectionWrapper.styles';
import styled from 'styled-components';
const Container = styled.div `
  --tagColor: ${brand.primary.orange};
  --imgColor: ${brand.white};
  --bgColor: ${brand.secondary.lightGrey};
  --fgColor: ${brand.primary.blue};

  background-color: var(--bgColor);
  border-bottom: 8px solid ${brand.primary.orange};
  position: relative;

  &[data-layout-variant='form'] {
    border-top: 8px solid ${brand.primary.orange};
    border-bottom: none;

    @media ${until(Device.TabletLarge)} {
      border: none;
    }
  }
`;
const TagArea = styled.div `
  margin: 0 auto;
  max-width: var(--siteWidth);
  padding: 0 var(--sitePadding);

  [data-layout-variant='form'] & {
    @media ${until(Device.TabletLarge)} {
      display: none;
    }
  }
`;
const Tag = styled.span `
  ${paragraphSmall};
  ${fonts.apparat.semiBold};

  display: inline-block;
  margin: 0;
  padding: 8px ${fluid(20, 30)} 6px;
  text-transform: uppercase;
  background-color: var(--tagColor);
  color: ${brand.white};
  border-radius: 0 0 10px 10px;

  position: absolute;
  top: 100%;

  [data-layout-variant='form'] & {
    top: 0;
  }
`;
const Inner = styled(SectionWrapper) `
  overflow: hidden;

  ${SectionWrapperStyles.Inner} {
    ${baseGrid};
  }

  @media ${from(Device.DesktopSmall)} {
    &[data-layout='default'] {
      ${SectionWrapperStyles.Inner} {
        min-height: 500px;
      }
    }
  }
`;
const ContentWrapper = styled.div `
  grid-row: 2;
  grid-column: span 24;
  padding: ${fluid(20, 108)} 0;
  color: var(--fgColor);

  @media ${from(Device.TabletLarge)} {
    grid-row: 1;

    ${Inner}[data-layout='default'] & {
      grid-column: span 15;
    }
  }

  @media ${from(Device.DesktopSmall)} {
    ${Inner}[data-layout='default'] & {
      grid-column: span 12;
    }
  }

  @media ${from(Device.Desktop)} {
    ${Inner}[data-layout='default'] & {
      grid-column: span 12;
    }
  }
`;
const Info = styled.span `
  ${paragraphSmall};

  display: block;
  margin: 0 0 ${fluid(10, 32)};
  text-transform: uppercase;
  color: ${brand.base.blue};
  opacity: 0.5;
`;
const Date = styled.time `
  text-transform: uppercase;
  margin: 0;
`;
const Title = styled.h1 `
  ${h4};

  margin: 0 0 ${fluid(10, 32)};
`;
const Content = styled.div `
  ${contentStyles};
  opacity: 0.5;
`;
const ButtonWrapper = styled.div `
  display: flex;
  gap: ${fluid(16, 24)};
  flex-wrap: wrap;
  margin: ${fluid(18, 40)} 0 0;

  [data-layout-variant='form'] & {
    display: none;
  }
`;
const CapacityLabel = styled.div `
  ${paragraphSmall};
  ${fonts.apparat.bold};
  text-transform: uppercase;
  margin: 0;
  border: 2px solid ${brand.primary.blue};
  border-radius: 10px;
  padding: 5px ${fluid(20, 30)};
  display: grid;
  align-items: center;
  justify-content: center;
`;
const ImageWrapper = styled.div `
  ${transition('transform', 0.75)};

  --imgWidth: calc(100% + var(--sitePadding));

  grid-row: 1;
  grid-column: span 24;
  display: flex;
  position: relative;
  transition-delay: 200ms;

  @media ${from(Device.TabletLarge)} {
    grid-column: 17 / span 8;
  }

  @media ${from(Device.DesktopSmall)} {
    --imgWidth: min(50vw, calc(1920px * 0.5));

    grid-column: 16 / span 9;
    transition-duration: 0.9s;
  }

  @media ${from(Device.Desktop)} {
    transition-duration: 1.2s;
  }

  ${Container}[data-animate='false'] & {
    transform: translateX(90%);
  }
`;
const ImageInner = styled.div `
  overflow: hidden;
  position: relative;
  flex: 1 0 var(--imgWidth);
  clip-path: url(#inner-hero-clip-path_svg__innerHero);
  z-index: 1;

  @media ${until(Device.TabletLarge)} {
    aspect-ratio: 363 / 227;
    border-top: 2px solid var(--imgColor);
    border-bottom: 2px solid var(--imgColor);
  }

  @media ${from(Device.TabletLarge)} {
    height: 100%;
  }
`;
const Img = styled(Image) `
  ${imageCoverContainer()};
`;
const EventPageHeroBannerStyles = {
    ButtonWrapper,
    CapacityLabel,
    Container,
    Content,
    ContentWrapper,
    Date,
    ImageInner,
    ImageWrapper,
    Img,
    Info,
    Inner,
    Tag,
    TagArea,
    Title,
};
export default EventPageHeroBannerStyles;
